import { useState, useEffect, useRef, createElement } from 'react';
import { Grid, Typography, InputBase, CardActionArea, Avatar, useTheme } from '@mui/material';
import { DashboardRounded, ViewQuiltRounded, LanguageRounded } from '@mui/icons-material';
import { ColorPicker } from '../../../../../Global/Components';
import { blue, teal } from '@mui/material/colors';
import { TaskIcon, FormIcon, ProcessIcon, DocIcon, KPIHubIcon } from '../../../../../Global/Icons';
import { AssetIcon, AuditIcon, RegistersIcon, RoutineIcon, ProjectIcon } from '../../../../../Global/Icons';
import { useHistory } from 'react-router-dom';
import StateManager from '../../../../../Global/StateManager';
import { useSelector } from 'react-redux';
import * as Icons from '@mui/icons-material';
import MenuList from '../MenuList';
import { v4 } from 'uuid';
import axios from 'axios';
import ACTION_TYPES from './ActionTypes';
import ImageSizeDialog from './ImageSizeDialog';

const shortcutsTypes = {
  work: { icon: <TaskIcon />, text: 'Work hub' },
  task: { icon: <TaskIcon />, text: 'Tasks' },
  form: { icon: <FormIcon />, text: 'Form hub' },
  formEntry: { icon: <FormIcon />, text: 'Form hub' },
  process: { icon: <ProcessIcon />, text: 'Process hub' },
  processEntry: { icon: <ProcessIcon />, text: 'Process hub' },
  doc: { icon: <DocIcon />, text: 'Doc hub' },
  area: { icon: <DocIcon />, text: 'Doc hub' },
  areas: { icon: <DocIcon />, text: 'Doc hub' },
  kpiDashboard: { icon: <DashboardRounded style={{ color: teal[500] }} />, text: 'KPI hub' },
  dashboard: { icon: <DashboardRounded style={{ color: blue[500] }} />, text: 'Dashboard' },
  kpi: { icon: <KPIHubIcon />, text: 'KPI hub' },
  asset: { icon: <AssetIcon />, text: 'Asset hub' },
  assetProfile: { icon: <AssetIcon />, text: 'Asset hub' },
  audit: { icon: <AuditIcon />, text: 'Audit hub' },
  register: { icon: <RegistersIcon />, text: 'Register hub' },
  project: { icon: <ProjectIcon />, text: 'Projects' },
  routine: { icon: <RoutineIcon />, text: 'Routines' },
  web: { icon: <LanguageRounded color="primary" />, text: 'Web page' },
  view: { icon: <ViewQuiltRounded />, text: 'View' },
  workBig: { icon: <TaskIcon style={{ height: '70%', width: '70%' }} />, text: 'Work hub' },
  taskBig: { icon: <TaskIcon style={{ height: '70%', width: '70%' }} />, text: 'Tasks' },
  formBig: { icon: <FormIcon style={{ height: '70%', width: '70%' }} />, text: 'Form hub' },
  formEntryBig: { icon: <FormIcon style={{ height: '70%', width: '70%' }} />, text: 'Form hub' },
  processBig: { icon: <ProcessIcon style={{ height: '70%', width: '70%' }} />, text: 'Process hub' },
  processEntryBig: { icon: <ProcessIcon style={{ height: '70%', width: '70%' }} />, text: 'Process hub' },
  docBig: { icon: <DocIcon style={{ height: '65%', width: '65%' }} />, text: 'Doc hub' },
  areaBig: { icon: <DocIcon style={{ height: '65%', width: '65%' }} />, text: 'Doc hub' },
  areasBig: { icon: <DocIcon style={{ height: '65%', width: '65%' }} />, text: 'Doc hub' },
  kpiDashboardBig: {
    icon: <DashboardRounded style={{ height: '70%', width: '70%', color: teal[500] }} />,
    text: 'KPI hub',
  },
  dashboardBig: {
    icon: <DashboardRounded style={{ height: '70%', width: '70%', color: blue[500] }} />,
    text: 'Dashboard',
  },
  kpiBig: { icon: <KPIHubIcon style={{ height: '70%', width: '70%' }} />, text: 'KPI hub' },
  assetBig: { icon: <AssetIcon style={{ height: '70%', width: '70%' }} />, text: 'Asset hub' },
  assetProfileBig: { icon: <AssetIcon style={{ height: '70%', width: '70%' }} />, text: 'Asset hub' },
  auditBig: { icon: <AuditIcon style={{ height: '70%', width: '70%' }} />, text: 'Audit hub' },
  registerBig: { icon: <RegistersIcon style={{ height: '70%', width: '70%' }} />, text: 'Register hub' },
  projectBig: { icon: <ProjectIcon style={{ height: '70%', width: '70%' }} />, text: 'Projects' },
  routineBig: { icon: <RoutineIcon style={{ height: '70%', width: '70%' }} />, text: 'Routines' },
  webBig: { icon: <LanguageRounded style={{ height: '70%', width: '70%', color: 'primary' }} />, text: 'Web page' },
  viewBig: { icon: <ViewQuiltRounded style={{ height: '70%', width: '70%' }} />, text: 'View' },
};

export default function ShortcutItem({ editable, item, onDelete, onChange, portalSpaceId, forDashboard = true }) {
  const { user } = useSelector(({ profile }) => profile);
  const [colorPicker, setColorPicker] = useState(null);
  const [color, setColor] = useState(undefined);
  const [text, setText] = useState(null);
  const [image, setImage] = useState(null);
  const [icon, setIcon] = useState({ icon: 'ImageSearch', color: '' });
  const [IconComponent, setIconComponent] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const [fontSettings, setFontSettings] = useState({});
  const [sizeDialog, setSizeDialog] = useState(false);
  const [imageSize, setImageSize] = useState('contain');
  //const [height, setHeight] = useState(null);
  const theme = useTheme();
  const history = useHistory();
  const titleTimer = useRef(null);
  const [elementId] = useState(v4());
  const [height, setHeight] = useState(null);
  const elementRef = useRef(null);
  useEffect(() => {
    setColor(item?.color);
    setText(item?.text || null);
    setImage(item?.image || null);
    setIcon(item?.icon || null);
    setFontSettings(item?.fontSettings || null);
    setImageSize(item?.imageSize || 'contain');
  }, [item]);

  useEffect(() => {
    const updateSize = () => {
      if (elementRef.current) {
        const rect = elementRef.current.getBoundingClientRect();
        setHeight(rect.height);
      }
    };

    updateSize(); // Initial update
    window.addEventListener('resize', updateSize); // Update on resize

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, []);
  // Need to handle typescript loader before we can use the component
  // useEffect(() => {
  //   //eslint-disable-next-line
  // }, [icon]);

  // if (icon) {
  //   const iconName = icon.icon ?? 'ChevronRightRounded';
  //   const iconColor = icon.color ?? '';
  //   const loadIcon = async () => {
  //     try {
  //       const { default: ImportedIcon } = await import(`@mui/icons-material/${iconName}`);

  //       setIconComponent(<ImportedIcon sx={{ color: iconColor }} />);
  //     } catch (error) {
  //       console.error(`Icon "${iconName}" could not be loaded`, error);
  //     }
  //   };

  //   loadIcon();
  // }

  useEffect(() => {
    if (icon?.icon) {
      setIconComponent(
        createElement(Icons[icon?.icon], {
          style: {
            color: icon?.color
              ? icon?.color
              : image
              ? '#ffffff'
              : color
              ? theme.palette.getContrastText(color)
              : theme.palette.secondary,
            height: height > 100 && !image ? 'calc(100% - 50px)' : undefined,
            width: height > 100 && !image ? 'calc(100% - 50px)' : undefined,
          },
        }),
      );
    }
    //eslint-disable-next-line
  }, [icon, height]);

  function saveColor(col) {
    setColor(col);
    onChange({ color: col });
  }

  function saveIcon(icon) {
    setIcon(icon);
    onChange({ icon: icon });
  }

  function saveTitle(title) {
    setText(title);
    if (titleTimer.current != null) {
      clearTimeout(titleTimer.current);
    }
    titleTimer.current = setTimeout(() => onChange({ text: title }), 1000);
  }

  function saveImageSize(size) {
    setImageSize(size);
    onChange({ imageSize: size });
  }

  function handleOpenSize() {
    setSizeDialog(true);
  }

  function saveFontSettings(settings) {
    setFontSettings(settings);
    onChange({ fontSettings: settings });
  }

  function getWebPageIcon() {
    let parsed;
    try {
      parsed = new URL(item.link);
    } catch (_) {
      return null;
    }
    return `https://t0.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${parsed.host}&size=64`;
  }

  const webPageIcon = item?.type === 'web' ? getWebPageIcon() : null;

  function extractId(gridClass, type = 'process') {
    const prefixes = [
      `completed-${type}-entries-`,
      `working-${type}-entries-`,
      `held-${type}-entries-`,
      `cancelled-${type}-entries-`,
      `all-${type}-entries-`,
      `${type}-`,
    ];
    for (let prefix of prefixes) {
      if (gridClass.startsWith(prefix)) {
        return gridClass.split(prefix)[1];
      }
    }
    return null;
  }

  function getLinkForView(gridClass) {
    if (gridClass === 'controlledDocHub') {
      return '/DocLibrary/controlled';
    }
    if (gridClass === 'bookmark') {
      return '/DocLibrary/bookmarked';
    }
    if (gridClass === 'responsibleDocHub') {
      return '/DocLibrary/responsible';
    }
    if (gridClass.startsWith('docArea-')) {
      const area = gridClass.split('-')[1];
      if (area) {
        return `/DocLibrary/areas/${area}`;
      }
    }
    if (gridClass.startsWith('docAreaNavigation-')) {
      const area = gridClass.split('-')[1];
      const folder = gridClass.split('-')[2];
      if (area && folder) {
        return `/DocLibrary/areas/${area}/${folder}`;
      }
    }
    if (gridClass === 'my-tasks-working') {
      return '/tasks/my';
    }
    if (gridClass === 'assigned-tasks-working') {
      return '/tasks/assigned';
    }
    if (gridClass.includes('process')) {
      if (gridClass === 'processes-working-entries') {
        return '/processes/working';
      }
      if (gridClass === 'processes-completed-entries') {
        return '/processes/completed';
      }
      if (gridClass === 'processes-held-entries') {
        return '/processes/held';
      }
      if (gridClass === 'processes-cancelled-entries') {
        return '/processes/cancelled';
      }
      if (
        gridClass.startsWith('completed-process-entries-') ||
        gridClass.startsWith('working-process-entries-') ||
        gridClass.startsWith('held-process-entries-') ||
        gridClass.startsWith('cancelled-process-entries-') ||
        gridClass.startsWith('all-process-entries-')
      ) {
        // extract process id from class name by pattern
        const processId = extractId(gridClass, 'process');
        if (processId) {
          return `/processes/${processId}`;
        }
      }
    }
    if (gridClass.includes('form')) {
      if (gridClass === 'forms-working-entries') {
        return '/forms/working';
      }
      if (gridClass === 'forms-completed-entries') {
        return '/forms/completed';
      }
      if (
        gridClass.startsWith('completed-form-entries-') ||
        gridClass.startsWith('working-form-entries-') ||
        gridClass.startsWith('all-form-entries-')
      ) {
        const formId = extractId(gridClass, 'form');
        if (formId) {
          return `/forms/${formId}`;
        }
      }
    }
    if (gridClass === 'assetTasks') {
      return '/asset/tasks';
    }
    if (gridClass === 'assets') {
      return '/asset/all';
    }
    if (gridClass.startsWith('register-')) {
      const registerId = extractId(gridClass, 'register');
      return `/registers/${registerId}`;
    }
  }

  function getItemLink() {
    if (item.link && !(item.type === 'workspace' && user?.access === 'portal')) return item.link;
    if (item.type === 'project') return `/tasks/projects/project/${item.id}`;
    if (item.type === 'routine') return `/tasks/routine/${item.id}`;
    if (item.type === 'form')
      return portalSpaceId ? `/forms/${item.id}?portalSpaceId=${portalSpaceId}` : `/forms/${item.id}`;
    if (item.type === 'process')
      return portalSpaceId ? `/processes/${item.id}?portalSpaceId=${portalSpaceId}` : `/processes/${item.id}`;
    if (item.type === 'asset') return `/asset/${item.id}`;
    if (item.type === 'assetProfile') return `/asset/profile/${item.id}`;
    if (item.type === 'audit') return `/audits/${item.id}`;
    if (item.type === 'register') return `/registers/${item.id}`;
    if (item.type === 'doc') return `/DocLibrary/preview/${item.id}`;
    if (item.type === 'area') return `/DocLibrary/areas/${item.id}`;
    if (item.type === 'kpiDashboard') return `/kpiHub/dashboard/${item.id}`;
    if (item.type === 'dashboard' || (item.type === 'workspace' && user?.access === 'portal')) {
      if (user?.access === 'portal') {
        return portalSpaceId
          ? `/portal/dashboard/${item.id}?portalSpaceId=${portalSpaceId}`
          : `/portal/dashboard/${item.id}`;
      } else {
        return `/tasks/workspaces/${item.id}`;
      }
    }

    if (item.type === 'docFolder') {
      if (item.subId) {
        return `/DocLibrary/areas/${item.id}/${item.subId}`;
      }
    }
    if (item.type === 'view') {
      const viewId = item.id;
      if (item.access === 'private' && user?._id !== item.userId) {
        StateManager.setErrorAlert('You do not have access to this view');
        return '#';
      }
      const viewLink = getLinkForView(item.gridClass);
      if (viewLink) {
        return `${viewLink}?viewId=${viewId}`;
      }
    }

    return '#';
  }

  function onClick() {
    if (item.type === 'task' && item.id) {
      StateManager.selectTask(item.id);
      return;
    }
    if (item.type === 'web') {
      window.open(item.link, '_blank');
      return;
    }
    const link = getItemLink();
    history.push(link);
  }

  function uploadFile(file) {
    setUploadingImage(true);
    const data = new FormData();
    data.append('file', file);
    axios
      .post(`/uploader/upload-single`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(({ data }) => {
        setImage(data.file);
        onChange({ image: data.file }, { h: 8 });
        setUploadingImage(false);
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
        setUploadingImage(false);
      });
  }

  return (
    <Grid
      container
      style={{
        height: forDashboard ? '100%' : null,
        background: image ? `url('${image.location}') center center / ${imageSize} no-repeat` : color,
      }}
      wrap="nowrap"
      direction={'column'}
      id={elementId}
      ref={elementRef}
    >
      {editable ? (
        <>
          <Grid
            container
            item
            alignItems="center"
            wrap="nowrap"
            style={{
              background: image ? `rgba(0,0,0, .5)` : 'inherit',
              maxHeight: 'fit-content',
              position: 'absolute',
              bottom: 0,
              paddingBottom: '5px',
              paddingLeft: '10px',
            }}
          >
            {webPageIcon ? (
              <Avatar variant="rounded" style={{ height: 24, width: 24 }} src={webPageIcon}>
                <LanguageRounded color="primary" />
              </Avatar>
            ) : icon && icon.icon !== 'ImageSearch' ? (
              createElement(Icons[icon.icon], {
                style: {
                  color: icon?.color
                    ? icon?.color
                    : image
                    ? '#ffffff'
                    : color
                    ? theme.palette.getContrastText(color)
                    : theme.palette.secondary,
                },
              })
            ) : (
              ACTION_TYPES[item.type]?.icon
            )}

            <InputBase
              style={{ marginLeft: 8 }}
              inputProps={{
                style: { fontSize: fontSettings?.size || 18, textAlign: fontSettings?.alignment ?? 'left' },
              }}
              value={text != null ? text : item.title}
              onChange={(e) => saveTitle(e.target.value)}
              className="non-draggable"
              sx={{
                width: '100%',
                color: image ? '#FFFFFF' : color ? theme.palette.getContrastText(color) : icon?.color || 'primary.main',
                fontSize: fontSettings?.size || 18,
                textAlign: fontSettings?.alignment ?? 'left',
                justifyContent: fontSettings?.alignment ?? 'left',
              }}
            />
            <ColorPicker
              anchor={colorPicker}
              open={Boolean(colorPicker)}
              column={400}
              customPicker
              onClose={(res) => {
                if (res?.color) {
                  saveColor(res?.color);
                }
                setColorPicker(null);
              }}
              className="non-draggable"
            />
            <MenuList
              image={image}
              item={item}
              uploadFile={uploadFile}
              uploadingImage={uploadingImage}
              onChange={onChange}
              color={color}
              setColorPicker={setColorPicker}
              icon={icon}
              saveIcon={saveIcon}
              onDelete={onDelete}
              fontSettings={fontSettings}
              saveFontSettings={saveFontSettings}
              mode={'shortcut'}
              setSizeDialog={handleOpenSize}
            />
          </Grid>
          <ImageSizeDialog
            open={sizeDialog}
            onClose={() => setSizeDialog(false)}
            onChange={(value) => saveImageSize(value)}
          />
        </>
      ) : (
        <Grid
          container
          item
          component={CardActionArea}
          onClick={onClick}
          style={{
            height: '100%',
            width: '100%',
            borderRadius: 5,
            background: image || color,
            justifyContent: height > 100 ? 'flex-end' : 'center',
          }}
          wrap="nowrap"
          direction="column"
        >
          {!item?.image && height > 100 ? (icon ? IconComponent : shortcutsTypes[`${item.type}Big`]?.icon) : null}
          <Grid
            container
            alignItems={'center'}
            justuifyContent={'flex-end'}
            direction={'column'}
            wrap="nowrap"
            width="100%"
            maxHeight="100%"
          >
            <Grid
              container
              wrap="nowrap"
              justifyContent={'center'}
              sx={{ background: image ? `rgba(0,0,0, .5)` : undefined, py: '5px' }}
            >
              <Grid
                container
                item
                height={30}
                width={30}
                alignItems={'center'}
                mx={1}
                display={height > 100 ? 'none' : 'flex'}
              >
                {webPageIcon ? (
                  <Avatar src={webPageIcon} variant="rounded" style={{ height: 24, width: 24 }}>
                    <LanguageRounded color="primary" />
                  </Avatar>
                ) : !icon && height <= 100 ? (
                  shortcutsTypes[item.type]?.icon
                ) : icon && height <= 100 ? (
                  IconComponent
                ) : item?.image ? (
                  icon ? (
                    IconComponent
                  ) : (
                    shortcutsTypes[item.type]?.icon
                  )
                ) : null}
              </Grid>

              <Typography
                sx={{
                  ml: 1,
                  fontSize: fontSettings?.size || 18,
                  justifyContent: fontSettings?.alignment || 'start',
                  textAlign: fontSettings?.alignment || 'left',
                }}
                style={{
                  color: image ? '#FFFFFF' : color ? theme.palette.getContrastText(color) : undefined,
                  fontSize: fontSettings?.size || 18,
                  borderRadius: 2,
                  alignItems: 'center',
                  justifyContent: fontSettings?.alignment || 'start',
                  textAlign: fontSettings?.alignment || 'left',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {item.text || item.title}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
